import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Breadcrumbs, Chip } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  chip: {
    margin: '2px 0 2px 0'
  }
}));

const BreadCrumbPath = props => {
  const classes = useStyles();
  const { path, baseUrl } = props;
  let urlParams = [];
  return (
    <Breadcrumbs aria-label='breadcrumb'>
      {path.map((segment, i) => {
        const { name, id } = segment;
        if (id) urlParams.push(id);
        return (
          <Chip
            key={i}
            className={classes.chip}
            component='a'
            href={urlParams.length > 0 ? `${baseUrl || ''}${urlParams.join(',')}` : '#'}
            label={name}
            size='small'
            clickable={urlParams.length > 0}
          />
        );
      })}
    </Breadcrumbs>
  );
};

export default BreadCrumbPath;
